import './src/styles/global.css';
import './src/styles/slick-theme.css';
import './src/styles/slick.css';